/* eslint-disable max-len */

export default {
    UKWideCoverage: {
        id: 'spm.breakDownModal.UKWideCoverage',
        defaultMessage: 'UK-wide coverage'
    },
    UKWideCoverageHelp: {
        id: 'spm.breakDownModal.UKWideCoverageHelp',
        defaultMessage: 'We provide 24/7 assistance throughout the UK for your car and anyone travelling in it.'
    },
    RoadsideAssistance: {
        id: 'spm.breakDownModal.RoadsideAssistance',
        defaultMessage: 'Roadside assistance*'
    },
    RoadsideAssistanceHelp: {
        id: 'spm.breakDownModal.RoadsideAssistanceHelp',
        defaultMessage: 'This provides roadside assistance when you’re more than a quarter of a mile from your home address. If we can’t fix your car at the roadside, we’ll take it to a destination of your choice within 10 miles of the breakdown and provide reimbursement of taxi costs up to 20 miles for the driver and passengers.'
    },
    CoverAtHome: {
        id: 'spm.breakDownModal.CoverAtHome',
        defaultMessage: 'Cover at home'
    },
    CoverAtHomeHelp: {
        id: 'spm.breakDownModal.CoverAtHomeHelp',
        defaultMessage: 'We’ll attend if your car breaks down at home or within a quarter of a mile from your home address. If we can’t fix your vehicle at home, we’ll provide a tow to the nearest garage within 10 miles.'
    },
    RecoveryUK: {
        id: 'spm.breakDownModal.RecoveryUK',
        defaultMessage: 'Recovery to anywhere in the UK*'
    },
    RecoveryUKHelp: {
        id: 'spm.breakDownModal.RecoveryUKHelp',
        defaultMessage: 'If you break down a long way from home, we\'ll save you the hassle and expense of getting back. If we can’t repair your car at the roadside, we’ll arrange for it and the people in it to be taken to a destination of your choice, anywhere in the UK.'
    },
    EuropeanCover: {
        id: 'spm.breakDownModal.EuropeanCover',
        defaultMessage: 'Cover in Europe'
    },
    EuropeanCoverHelp: {
        id: 'spm.breakDownModal.EuropeanCoverHelp',
        defaultMessage: 'If you break down in Europe, we’ll arrange for your car to be repaired at the roadside or taken to the nearest suitable repairer. And, if no-one can drive due to accidental injury or sudden illness, we’ll arrange for a chauffeur to bring you back to the UK.'
    },
    AddButton: {
        id: 'spm.breakDownModal.AddButton',
        defaultMessage: 'Add'
    },
    RemoveButton: {
        id: 'spm.breakDownModal.RemoveButton',
        defaultMessage: 'Remove'
    },
    MotorhomeAssistanceContent: {
        id: 'spm.breakDownModal.MotorhomeAssistanceContent',
        defaultMessage: 'What would you do if your motorhome broke down? Saga Motorhome Breakdown Assistance covers your motorhome and anyone driving it. We will cover you following an accident, breakdown or puncture anywhere in the UK. If your motorhome is unable to be fixed at the roadside, we will take you home or to a garage within ten miles of your destination.'
    },
    MotorhomeAssistancePlusContent: {
        id: 'spm.breakDownModal.MotorhomeAssistancePlusContent',
        defaultMessage: 'Do you take your motorhome abroad? With this level of cover, we\'ll cover your motorhome and anyone driving it. We will cover you following an accident, breakdown or puncture anywhere in the UK. If your motorhome is unable to be fixed at the roadside, we will take you home or to a garage within ten miles of your destination, plus breakdown assistance in 52 European countries.'
    },
    EssentialPart1: {
        id: 'spm.breakDownMobile.EssentialPart1',
        defaultMessage: 'a year - includes: Roadside repair'
    },
    EssentialPart2: {
        id: 'spm.breakDownMobile.EssentialPart2',
        defaultMessage: '24/7 cover. We’ll try to fix your car as long as it’s at least ¼ mile away from your home. If we are unable to fix your car at the roadside we’ll take you and your car to a destination of your choice within 10 miles of your breakdown and provide reimbursement of taxi costs up to 20 miles for the driver and passengers.'
    },
    HomeCallPart1: {
        id: 'spm.breakDownMobile.HomeCallPart1',
        defaultMessage: 'a year - includes: Roadside repair, Recovery at home'
    },
    HomeCallPart2: {
        id: 'spm.breakDownMobile.HomeCallPart2',
        defaultMessage: 'What would you do if your car broke down at home? Home Call brings assistance to your doorstep by extending your cover to within ¼ mile of your home. This’ll help get you back up and running and free to get on with your day.'
    },
    NationalRecoveryPart1: {
        id: 'spm.breakDownMobile.NationalRecoveryPart1',
        defaultMessage: 'a year - includes: Roadside repair, National recovery'
    },
    NationalRecoveryPart2: {
        id: 'spm.breakDownMobile.NationalRecoveryPart2',
        defaultMessage: 'What would you do if you broke down a long way from home? Providing the breakdown happens more than ¼ mile from your home, we\'ll save you the hassle and costs of getting back. If we\'re unable to repair your car, we\'ll arrange for you and it to be taken to a destination of your choice, anywhere in the UK!'
    },
    ComprehensivePart1: {
        id: 'spm.breakDownMobile.ComprehensivePart1',
        defaultMessage: 'a year - includes: Roadside repair, Recovery at home, National recovery'
    },
    ComprehensivePart2: {
        id: 'spm.breakDownMobile.ComprehensivePart2',
        defaultMessage: 'This level of cover includes all the benefits above as well as a hire car, public transport or overnight accommodation if you are unable to use your car because repairs cannot be made that day, or if your car has been stolen.'
    },
    PremierPart1: {
        id: 'spm.breakDownMobile.PremierPart1',
        defaultMessage: 'a year - includes: Roadside repair, Recovery at home, National recovery, European cover'
    },
    PremierPart2: {
        id: 'spm.breakDownMobile.PremierPart2',
        defaultMessage: 'Do you ever drive abroad? Extend your cover to Europe and in the event of a breakdown we’ll arrange for your car to be repaired at the roadside or taken to the nearest suitable repairer. In the unfortunate event that no one can drive due to an accidental injury or sudden illness, we will arrange for a chauffeur to bring you safely back to the UK.'
    }
};
